import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/nft/video-desktop.mp4")